import { useState, useEffect } from 'react'
import { useSetorService } from 'hooks/useSetorService'


export const useDashboardModal = (config, updateCellConfig) => {
  const sectorService = useSetorService()

  const [modalOpen, setModalOpen] = useState(false)
  const [modalSection, setModalSection] = useState('kpis')
  const [modalIndex, setModalIndex] = useState(0)
  const [selectedType, setSelectedType] = useState('')
  const [selectedSector, setSelectedSector] = useState(null)

  const [sectors, setSectors] = useState([])
  const [loadingSectors, setLoadingSectors] = useState(false)

  useEffect(() => {
    if (modalOpen) {
      const fetchSectors = async () => {
        const list = await sectorService.listarSetoresAsync(setLoadingSectors)
        if (list) {
          setSectors(list)
        }
      }
      fetchSectors()
    }
  }, [modalOpen])

  const handleOpenConfig = (section, index) => {
    const cell = config[section][index]
    setModalSection(section)
    setModalIndex(index)
    setSelectedType(cell?.type || '')
    setSelectedSector(cell?.sectorId ? { id: cell.sectorId, nome: cell.sectorName } : null)
    setModalOpen(true)
  }

  const handleConfirmConfig = () => {
    updateCellConfig(modalSection, modalIndex, {
      type: selectedType,
      sectorId: selectedSector?.id || null,
      sectorName: selectedSector?.nome || null,
    })
    setModalOpen(false)
  }

  return {
    modalOpen,
    modalSection,
    modalIndex,
    selectedType,
    setSelectedType,
    selectedSector,
    setSelectedSector,
    sectors,
    loadingSectors,
    handleOpenConfig,
    handleConfirmConfig,
    setModalOpen,
  }
}
